import React, { Component } from 'react';
import { Nav, Spinner } from 'react-bootstrap';
import UserLayout from '../../layouts/User';
import { Link, Route, Routes, Navigate } from 'react-router-dom';
import ProfileDetails from './ProfileDetails/ProfileDetails';
import ProfileCommissions from './ProfileCommissions/ProfileCommissions';
import ProfileAddress from './ProfileAddress/ProfileAddress';
import ProfileCertificates from './ProfileCertificates/ProfileCertificates';
import AccountContext from './AccountContext';
import { Api, EventBus } from 'src/helpers/new';
import { getState } from 'src/helpers/localStorage';
import withRouterAndRedux from 'src/hoc/withRouterAndRedux';
import { ERROR_MESSAGES } from 'src/helpers/constants';
class Profile extends Component {
    state = {
        notificationTabData: [],
        detailsTabData: {},
        failedToLoadMsg: '',
        loading: true,
    };

    componentDidMount = () => {
        this.fetchUserDetails();
    };

    fetchUserDetails = async () => {
        try {
            const userId = getState('user')?._id;

            if (!userId) {
                EventBus.dispatch('toast', {
                    type: 'error',
                    message: ERROR_MESSAGES.USER_NOT_FOUND_ERROR,
                });
                this.setState({
                    loading: false,
                    failedToLoadMsg: ERROR_MESSAGES.USER_NOT_FOUND_ERROR,
                });
                return;
            }

            const { response, message, success } = await Api.call('GET', '/users/' + userId);

            if (success) {
                this.setState({
                    detailsTabData: response,
                    notificationTabData: response?.mailingLists,
                    loading: false,
                });
            } else {
                this.setState({
                    failedToLoadMsg: message,
                    loading: false,
                });
            }
        } catch (error) {
            this.setState({
                failedToLoadMsg: ERROR_MESSAGES.USER_DETAILS_LOAD_ERROR,
                loading: false,
            });
        }
    };

    render() {
        const { notificationTabData, detailsTabData, failedToLoadMsg, loading } = this.state;
        const { fetchUserDetails } = this;

        if (loading) {
            return (
                <div className='center-loading big'>
                    <Spinner animation='border' />
                </div>
            );
        }

        if (failedToLoadMsg) {
            return (
                <div className='alert alert-danger' role='alert'>
                    {failedToLoadMsg}
                </div>
            );
        }

        const isShowCommision = process.env.REACT_APP_PROFILE_COMMISSION_SHOW == 'false' ? false : true;

        return (
            <div
                style={{
                    padding: '20px',
                    background: '#f5fafd',
                    height: '100%',
                }}
            >
                <AccountContext.Provider
                    value={{
                        notificationTabData,
                        detailsTabData,
                        failedToLoadMsg,
                        fetchUserDetails,
                    }}
                >
                    <UserLayout>
                        {[
                            '/profile/details',
                            '/profile/addresses',
                            '/profile/commissions',
                            '/profile/notifications',
                            '/profile/settings',
                            '/profile/certificates',
                        ].includes(this.props.location.pathname) && (
                            <Nav variant='tabs' activeKey={this.props.location.pathname}>
                                <Nav.Item key='profile'>
                                    <Nav.Link as={Link} eventKey={`/profile/details`} to={`/profile/details`}>
                                        Details
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item key='profile-address'>
                                    <Nav.Link as={Link} eventKey={`/profile/addresses`} to={`/profile/addresses`}>
                                        Addresses
                                    </Nav.Link>
                                </Nav.Item>
                                {isShowCommision && (
                                    <Nav.Item key='profile-commissions'>
                                        <Nav.Link
                                            as={Link}
                                            eventKey={`/profile/commissions`}
                                            to={`/profile/commissions`}
                                        >
                                            Commissions
                                        </Nav.Link>
                                    </Nav.Item>
                                )}
                                <Nav.Item key='profile-certificates'>
                                    <Nav.Link as={Link} eventKey={`/profile/certificates`} to={`/profile/certificates`}>
                                        Certificates
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        )}
                        <div
                            style={{
                                background: '#fff',
                                padding: '20px',
                            }}
                            className='profile-wrapper'
                        >
                            <Routes>
                                <Route path='details' element={<ProfileDetails />} />
                                <Route path='addresses' element={<ProfileAddress />} />
                                <Route path='commissions' element={<ProfileCommissions />} />
                                <Route path='certificates' element={<ProfileCertificates />} />
                                <Route path='*' element={<Navigate to='details' />} />
                            </Routes>
                        </div>
                    </UserLayout>
                </AccountContext.Provider>
            </div>
        );
    }
}

export default withRouterAndRedux(
    Profile,
    (state) => ({
        loggedIn: state.loggedIn,
    }),
    null,
);
